// Main JavaScript entry point
// Mobile PDP gallery: one list (ul) for desktop and mobile; theme updateMedia reorders it on variant change.

// Mobile fixed add to cart button scroll detection
function initializeMobileAddToCartScrollDetection() {
  const mobileBreakpoint = 768;

  function handleScroll() {
    // Only run on mobile devices
    if (window.innerWidth > mobileBreakpoint) return;

    const fixedButton = document.querySelector(".mobile-add-to-cart-fixed");
    if (!fixedButton) return;

    // Calculate if user has scrolled to the bottom
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // Add a small threshold (10px) to account for rounding differences
    const isAtBottom = scrollTop + windowHeight >= documentHeight - 10;

    // Add or remove the 'at-bottom' class
    if (isAtBottom) {
      fixedButton.classList.add("at-bottom");
    } else {
      fixedButton.classList.remove("at-bottom");
    }
  }

  function handleResize() {
    if (window.innerWidth <= mobileBreakpoint) {
      // Re-check scroll position on resize
      handleScroll();
    } else {
      // Remove class if switching to desktop
      const fixedButton = document.querySelector(".mobile-add-to-cart-fixed");
      if (fixedButton) {
        fixedButton.classList.remove("at-bottom");
      }
    }
  }

  // Add scroll event listener with throttling for better performance
  let scrollTimeout;
  window.addEventListener("scroll", () => {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
    scrollTimeout = setTimeout(handleScroll, 10);
  });

  // Add resize event listener
  window.addEventListener("resize", handleResize);

  // Initial check
  handleScroll();
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(initializeMobileAddToCartScrollDetection, 100);
});
window.addEventListener("load", () => {
  setTimeout(initializeMobileAddToCartScrollDetection, 100);
});
